import { VariaveisAmbiente } from 'config';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { CredenciaisListModel } from 'model/api/gestao/credenciamento/credenciais-list-model';

export function useGetCredenciaisDisponiveis() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<CredenciaisListModel>>();

    const getCredenciaisDisponiveis = useCallback(
        async (page: number, queryBusca: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || queryBusca?.length > 0 ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/Credenciamento/s2pay/credenciais-disponiveis${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: true
            })
        }
        , [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getCredenciaisDisponiveis,
    };
}